import { Controller } from '@hotwired/stimulus'

// Marketing header — single dropdown menu (For Dealers / Data & Tools).
//
// Click trigger to toggle open. Closes on Escape, outside-click, or focus
// leaving the menu container. Hover preview disabled per spec §8.9 (touch
// friendly is the default).
export default class extends Controller {
  static targets = ['trigger', 'menu']

  connect() {
    this._outsideClick = (e) => {
      if (!this.element.contains(e.target)) this.close()
    }
    this._escClose = (e) => {
      if (e.key === 'Escape') {
        this.close()
        if (this.hasTriggerTarget) this.triggerTarget.focus()
      }
    }
    document.addEventListener('click', this._outsideClick)
    document.addEventListener('keydown', this._escClose)
  }

  disconnect() {
    document.removeEventListener('click', this._outsideClick)
    document.removeEventListener('keydown', this._escClose)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    const open = this.menuTarget.dataset.open === 'true'
    if (!open) this._closeOthers()
    this.setOpen(!open)
  }

  // Close any other dropdown menus on the page so two never sit open at
  // once. event.stopPropagation() in toggle() prevents the document-level
  // outside-click handler from firing on the other controllers, which is
  // why we have to close them explicitly here.
  _closeOthers() {
    document.querySelectorAll('[data-marketing-dropdown-target="menu"][data-open="true"]').forEach((menu) => {
      if (menu === this.menuTarget) return
      menu.dataset.open = 'false'
      const trigger = menu.parentElement && menu.parentElement.querySelector('[data-marketing-dropdown-target="trigger"]')
      if (trigger) trigger.setAttribute('aria-expanded', 'false')
    })
  }

  close() {
    this.setOpen(false)
  }

  setOpen(open) {
    if (this.hasMenuTarget) this.menuTarget.dataset.open = open ? 'true' : 'false'
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute('aria-expanded', String(open))
  }
}
